import { memo, useState, useCallback } from '../../lib/teact/teact';

import App from '../App';
import PwaPreviewScreen from './larpers/PwaPreviewScreen';

/**
 * Shown only when the app runs as a PWA (`IS_PWA === true`).
 * Renders the preview screen first; once the user taps "Login"
 * it unmounts the preview and mounts the real Telegram App.
 */
const PwaRoot = () => {
  const [hasLoggedIn, setHasLoggedIn] = useState(false);

  const handleLogin = useCallback(() => {
    setHasLoggedIn(true);
  }, []);

  if (hasLoggedIn) {
    return <App />;
  }

  return <PwaPreviewScreen onLoginClick={handleLogin} />;
};

export default memo(PwaRoot);
